module.exports = __webpack_public_path__ + "img/fail.4e6ab18a.png";